var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { localized, msg } from '@lit/localize';
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
let InputNodeSettings = class InputNodeSettings extends LitElement {
    updated(_changedProperties) {
        if (_changedProperties.has('workflowExecutionData') || _changedProperties.has('node')) {
            this.selectedNodeExecution = this.workflowExecutionData?.connections_executions
                ?.filter(ce => ce.target_node_execution_id === this.node.node_id)
                .map(ce => this.workflowExecutionData?.nodes_executions?.find(ne => ne.node_execution_id === ce.source_node_execution_id))
                .find(ne => ne !== undefined);
        }
    }
    getOptionsNodeExecutions() {
        if (!this.workflowExecutionData || !this.node) {
            return [];
        }
        const nodeExecutions = this.workflowExecutionData.nodes_executions;
        const connectionExecutions = this.workflowExecutionData.connections_executions;
        const previousNodeExecutions = nodeExecutions.filter(ne => {
            return connectionExecutions.some(ce => {
                return ce.target_node_execution_id === this.node.node_id && ce.source_node_execution_id === ne.node_id;
            });
        });
        const options = previousNodeExecutions.map(ne => {
            return {
                value: ne.node_execution_id,
                label: `${ne.node_saved?.name} (${ne.key})`
            };
        });
        return options;
    }
    handleSelectChange(event) {
        const selectedValue = parseInt(event.detail.value);
        if (!this.workflowExecutionData) {
            return;
        }
        this.selectedNodeExecution = this.workflowExecutionData.nodes_executions?.find(ne => ne.node_execution_id === selectedValue);
    }
    render() {
        console.log('Selected Node Execution:', this.selectedNodeExecution);
        return html `
      <h3 class="input-node-settings__header">${msg('Input data', { id: 'inputNode.header', desc: 'Input data panel header' })}</h3>
      <div class="input-node-settings__content">
      <div class="input-node-settings__input-spacer"></div>
        ${this.workflowExecutionData
            ? html `
              <select-input
                class="input-node-settings__input"
                .options=${this.getOptionsNodeExecutions()}
                size="medium"
                @select-change=${this.handleSelectChange}
              ></select-input>
              <div class="input-node-settings__input-spacer"></div>

              ${this.selectedNodeExecution
                ? html `<json-displayer .data=${this.selectedNodeExecution.output_data}></json-displayer>`
                : html `<p>${msg('No input data selected.', { id: 'inputNode.noInputDataSelected', desc: 'No input data selected message' })}</p>`}
            `
            : html `
              <h3 class="message">
                ${msg('No execution data available. Please run the workflow to see input data.')}
              </h3>
            `}
      </div>
    `;
    }
};
InputNodeSettings.styles = css `
    :host {
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    .input-node-settings__header {
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      padding-bottom: 12px;
      border-bottom: 1px solid #ddd;
      background: #fff;
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .input-node-settings__content {
      box-sizing: border-box;
      flex: 1;
      overflow-y: auto;
      min-height: 0;
    }

    .input-node-settings__input {
      width: 100%;
    }

    .input-node-settings__input-spacer {
      height: 12px;
    }

    .message {
      padding: 16px;
      font-size: 0.9rem;
      color: #666;
    }
  `;
__decorate([
    property({ type: Object })
], InputNodeSettings.prototype, "node", void 0);
__decorate([
    property({ type: Object })
], InputNodeSettings.prototype, "workflowExecutionData", void 0);
__decorate([
    state()
], InputNodeSettings.prototype, "selectedNodeExecution", void 0);
InputNodeSettings = __decorate([
    localized(),
    customElement('input-node-settings')
], InputNodeSettings);
export { InputNodeSettings };
//# sourceMappingURL=InputNodeSettings.js.map